import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {FaIcon} from "../FaIcon";
import {Spinner} from "../Spinner";
import {Switch} from "../buttons/Swtich";
import {withTranslation} from 'react-i18next';


class EditClientFeaturesModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            saving: false,
            features: {
                dashboard: props.user.client_features?.dashboard || false,
                data_explorer: props.user.client_features?.data_explorer || false,
                connect: props.user.client_features?.connect !== false,
                reports: props.user.client_features?.reports !== false,
                insights: props.user.client_features?.insights || false,
            }
        };
        this.toggle = this.toggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    toggle() {
        this.setState({modal: !this.state.modal});
    }

    handleFeatureToggle(featureKey, checked) {
        this.setState({
            features: {
                ...this.state.features,
                [featureKey]: checked
            }
        });
    }

    handleSave() {
        this.setState({saving: true});
        const url = API_URL + `user/${this.props.user.id}/client-features`;
        new APIClient(url).call('POST', {client_features: this.state.features}).then((data) => {
            this.setState({saving: false});
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else {
                this.toggle();
                if (this.props.onSaved) this.props.onSaved();
            }
        });
    }

    render() {
        const {t, user} = this.props;

        const features = [
            {key: 'connect', icon: 'microchip', available: true},
            {key: 'reports', icon: 'wand-magic-sparkles', available: true},
            {key: 'dashboard', icon: 'chart-line', available: false},
            {key: 'data_explorer', icon: 'binoculars', available: false},
            {key: 'insights', icon: 'star', available: false},
        ];

        return (
            <>
                <a onClick={this.toggle} style={{cursor: 'pointer'}} title={t('agency_team.edit_features')}>
                    <FaIcon iconName="user-edit"/>
                </a>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <FaIcon iconName="user-edit"/>
                        {t('edit_client_features.title')}
                    </ModalHeader>
                    <ModalBody>
                        <div className="modal-section">
                            <div style={{marginBottom: '1.2em'}}>
                                <strong>{user.name}</strong>
                                <div style={{fontSize: '0.85em', color: '#999'}}>{user.email}</div>
                                {user.client_name && (
                                    <div style={{fontSize: '0.85em', color: '#999', marginTop: '0.2em'}}>
                                        {t('agency_team.client_label')}: {user.client_name}
                                    </div>
                                )}
                            </div>
                            <label>{t('invite_user.client_features_label')}</label>
                            {features.map(feature => (
                                <div key={feature.key}
                                     className={`invite-feature-row ${!feature.available ? '-coming-soon' : ''}`}>
                                    <div className="invite-feature-info">
                                        <FaIcon iconName={feature.icon} className="invite-feature-icon"/>
                                        <div className="invite-feature-text">
                                            <span className="invite-feature-name">{t(`invite_user.feature_${feature.key}`)}</span>
                                            <span className="invite-feature-desc">
                                                {feature.available ? t(`invite_user.feature_${feature.key}_desc`) : t('invite_user.coming_soon_desc')}
                                            </span>
                                        </div>
                                    </div>
                                    {feature.available ? (
                                        <Switch
                                            name={`feature_${feature.key}`}
                                            checked={this.state.features[feature.key]}
                                            onChange={(e) => this.handleFeatureToggle(feature.key, e.target.checked)}
                                            style={{margin: 0}}
                                        />
                                    ) : (
                                        <span className="invite-feature-badge-coming-soon">{t('invite_user.coming_soon')}</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.saving ? (
                            <Spinner color="positive small"/>
                        ) : (
                            <button className="btn -alt" onClick={this.handleSave}>
                                {t('edit_client_features.save')}
                            </button>
                        )}
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export const EditClientFeaturesModal = withTranslation()(EditClientFeaturesModalClass);
